var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapabilitiesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49996 3.00008C3.67153 3.00008 2.99996 3.67165 2.99996 4.50008C2.99996 5.32851 3.67153 6.00008 4.49996 6.00008C5.32839 6.00008 5.99996 5.32851 5.99996 4.50008C5.99996 3.67165 5.32839 3.00008 4.49996 3.00008ZM1.66663 4.50008C1.66663 2.93527 2.93515 1.66675 4.49996 1.66675C6.06477 1.66675 7.33329 2.93527 7.33329 4.50008C7.33329 6.06489 6.06477 7.33341 4.49996 7.33341C2.93515 7.33341 1.66663 6.06489 1.66663 4.50008Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3.00008C10.6716 3.00008 9.99996 3.67165 9.99996 4.50008C9.99996 5.32851 10.6716 6.00008 11.5 6.00008C12.3284 6.00008 13 5.32851 13 4.50008C13 3.67165 12.3284 3.00008 11.5 3.00008ZM8.66663 4.50008C8.66663 2.93527 9.93516 1.66675 11.5 1.66675C13.0648 1.66675 14.3333 2.93527 14.3333 4.50008C14.3333 6.06489 13.0648 7.33341 11.5 7.33341C9.93516 7.33341 8.66663 6.06489 8.66663 4.50008Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49996 10.0001C3.67153 10.0001 2.99996 10.6717 2.99996 11.5001C2.99996 12.3285 3.67153 13.0001 4.49996 13.0001C5.32839 13.0001 5.99996 12.3285 5.99996 11.5001C5.99996 10.6717 5.32839 10.0001 4.49996 10.0001ZM1.66663 11.5001C1.66663 9.93528 2.93515 8.66675 4.49996 8.66675C6.06477 8.66675 7.33329 9.93528 7.33329 11.5001C7.33329 13.0649 6.06477 14.3334 4.49996 14.3334C2.93515 14.3334 1.66663 13.0649 1.66663 11.5001Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.66675C11.8682 8.66675 12.1666 8.96521 12.1666 9.33341V10.8334H13.6666C14.0348 10.8334 14.3333 11.1319 14.3333 11.5001C14.3333 11.8683 14.0348 12.1667 13.6666 12.1667H12.1666V13.6667C12.1666 14.0349 11.8682 14.3334 11.5 14.3334C11.1318 14.3334 10.8333 14.0349 10.8333 13.6667V12.1667H9.33329C8.96509 12.1667 8.66663 11.8683 8.66663 11.5001C8.66663 11.1319 8.96509 10.8334 9.33329 10.8334H10.8333V9.33341C10.8333 8.96521 11.1318 8.66675 11.5 8.66675Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilitiesIcon);
export default __webpack_public_path__ + "static/media/CapabilitiesIcon.5f2b61589054a248bf982d7dcab4bf83.svg";
export { ForwardRef as ReactComponent };